import { createApp, App } from "vue";
import { registerPlugins } from "@/plugins";
import { vMaska } from 'maska/vue';
import i18n from "@/plugins/i18n";
import AppMain from "@/App.vue";
import VueApexCharts from "vue3-apexcharts";
import CountryFlag from 'vue-country-flag-next';

import "@/assets/scss/app.scss";

import "simplebar";
import "simplebar/dist/simplebar.css";

import "@vuepic/vue-datepicker/dist/main.css";

import "emoji-picker-element";

import "maz-ui/css/main.css";

import CountTo from "@/app/lib/CountTo.vue";
import ListMenu from "@/app/common/components/ListMenu.vue";
import Card from "@/app/common/components/Card.vue";
import Breadcrumb from "@/app/common/components/Breadcrumb.vue";
import TextField from "@/app/common/validationComponents/TextField.vue";
import TextArea from "@/app/common/validationComponents/TextArea.vue";
import router from "./router";

import * as Sentry from "@sentry/vue";
import appConfigs from "@/app/appConfigurations";

const app: App = createApp(AppMain);

// Plugins
registerPlugins(app);
app.use(i18n);
app.use(VueApexCharts);

// Components
app.component("CountTo", CountTo);
app.component("ListMenu", ListMenu);
app.component("Card", Card);
app.component("Breadcrumb", Breadcrumb);
app.component("TextField", TextField);
app.component("TextArea", TextArea);
app.component('CountryFlag', CountryFlag);

Sentry.init({
    app,
    dsn: appConfigs.sentry_dns,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", "https://complaint-api.caatdev.com"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

// Directives
app.directive('maska', vMaska);

app.mount("#app");
